// src/components/LoadingOverlay/UtilsLoadingOverlay.js
/**
 * 次の描画(paint)が反映されるタイミングまで待つ。
 * requestAnimationFrame を2回挟むことで、DOM更新→描画完了を待ちやすくする。
 */
export const waitForNextPaint = () =>
  new Promise((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => resolve());
    });
  });
